import React from 'react'
import type { DateHeaderProps } from 'react-big-calendar'
import { makeStyles, Typography } from '@paintscout/ui'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    color: theme.palette.text.primary,
    padding: theme.spacing(1),
    zIndex: 1000,
    position: 'relative'
  },
  label: {
    margin: 0,
    cursor: 'pointer',
    pointerEvents: 'auto',
    '&:hover': {
      color: theme.palette.primary.main
    }
  }
}))

export default function MonthDateHeader(props: DateHeaderProps) {
  const classes = useStyles()
  const { onDrillDown, label } = props
  return (
    <Typography className={classes.root} component={'div'} variant="body2" color="textSecondary" align="center">
      <p className={classes.label} onClick={onDrillDown}>
        {label}
      </p>
    </Typography>
  )
}
